import { axios, axios2 } from '@/lib/axios';

import { RegisterResponse } from '../types';

export type VerifyRegisterOtpDTO = {
  otp: string;
  email: string;
};

export const verifyLawyerOtp = (data: VerifyRegisterOtpDTO): Promise<RegisterResponse> => {
  return axios2.post(`/lawyer-api/lawyer-verify-email`, data);
};
